import { toISOString } from '@/utils/date';
import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    productID: item.id,
    product: {
      productID: item.id,
      ean: item.ean,
      description: item.description,
      ownProductYN: item.ownProductYN,
      domainID: item.domainID,
      domainProductCode: item.domainProductCode,
      collections: item.collections,
      productTypeID: item.productTypeID,
      printOnTicketYN: item.printOnTicketYN,
      inactiveYN: item.inactiveYN,
      stockItemYN: item.stockItemYN
    },
    widthInMm: ConvertCentimetersToMillimeters(item.width),
    actualWidthInMm: ConvertCentimetersToMillimeters(item.actualWidth),
    lockSeamWidthInMm: ConvertCentimetersToMillimeters(item.lockSeamWidth),
    defaultBottomFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultBottomFinishMeasurementInCm),
    defaultSideFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultSideFinishMeasurementInCm),
    defaultTopFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultTopFinishMeasurementInCm),
    discontinuationDate: toISOString(item.discontinuationDate)
  };
  delete dto.id;
  delete dto.productTypeID;
  delete dto.ean;
  delete dto.description;
  delete dto.ownProductYN;
  delete dto.domainID;
  delete dto.domainProductCode;
  delete dto.collections;
  delete dto.printOnTicketYN;
  delete dto.inactiveYN;
  delete dto.width;
  delete dto.patternHeight;
  delete dto.lockSeamWidth;
  delete dto.defaultTopFinishMeasurementInCm;
  delete dto.defaultSideFinishMeasurementInCm;
  delete dto.defaultTopFinishMeasurementInCm;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    ...dto.product,
    id: dto.productID,
    width: ConvertMillimetersToCentimeters(dto.widthInMm),
    actualWidth: ConvertMillimetersToCentimeters(dto.actualWidthInMm),
    lockSeamWidth: ConvertMillimetersToCentimeters(dto.lockSeamWidthInMm),
    defaultBottomFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultBottomFinishMeasurementInMm),
    defaultSideFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultSideFinishMeasurementInMm),
    defaultTopFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultTopFinishMeasurementInMm)
  };
  item.collections = dto.product && Object.values(dto.product.collections);
  delete item.productID;
  delete item.product;
  delete item.widthInMm;
  delete item.actualWidthInMm;
  delete item.lockSeamWidthInMm;
  delete item.defaultBottomFinishMeasurementInMm;
  delete item.defaultSideFinishMeasurementInMm;
  delete item.defaultTopFinishMeasurementInMm;
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };
